import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { editVehiclesByIdFailed, editVehiclesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* editVehiclesById(action) {
  try {
    if (!action.payload || !action.payload.device_id) {
      throw new Error('ID not found');
    }
    const { device_id: deviceId, ...pool } = action.payload;
    const url = `${BACKEND_MDS_URL}/agency/vehicles/${deviceId}`;
    const response = yield makeRequest(url, pool, action, 'PUT', true, {
      Accept: 'application/json;version=1.2.0',
    });
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(editVehiclesByIdSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(editVehiclesByIdFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(editVehiclesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
